import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { editVarianceIndividual } from "../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { useMyProfileQuery } from "../../../../services/profileService/profile-api";
import { PermissionChecker } from "../../../../services/varianceService/util/PermissionChecker";
import { ReportedByDetails } from "./ReportedByDetails";

function IndividualDetails() {
  const dispatch = useAppDispatch();
  const individual = useAppSelector(
    (state) => state.varianceRequest.varianceRequest.individual
  );
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const { data, isLoading, isError } = useMyProfileQuery();
  const canEdit = (): boolean => {
    if (isLoading || isError || !data) {
      return false;
    }

    return PermissionChecker.canEditVariance(data, incident);
  };
  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Card sx={{ borderRadius: "10px", marginBottom: "10px" }}>
            <CardHeader
              sx={{
                marginBottom: "0px",
                paddingBottom: "3px",
                paddingTop: "3px",
                borderBottom: "solid",
                borderColor: "gray",
              }}
              title={
                <Typography variant="h6" color="gray">
                  Individual Details
                </Typography>
              }
            />
        <CardContent>
          {" "}
          <Stack direction="row" gap={2} marginBottom="10px">
            <TextField
              disabled={!canEdit()}
              name="lastName"
              label="Last Name"
              value={individual.lastName}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
              size="small"
              InputLabelProps={{ shrink: true }}
            />{" "}
            <TextField
              disabled={!canEdit()}
              name="firstName"
              label="First Name"
              value={individual.firstName}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
              size="small"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              disabled={!canEdit()}
              name="age"
              label="Age"
              type="number"
              value={individual.age || null}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
            />{" "}
          </Stack>{" "}
          <Stack direction="row" gap={2}>
            <TextField
              disabled={!canEdit()}
              name="homePhone"
              label="Home Phone"
              type="tel"
              value={individual.homePhone}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
              size="small"
            />
            <TextField
              disabled={!canEdit()}
              name="mobilePhone"
              label="Mobile Phone"
              type="tel"
              value={individual.mobilePhone}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
              size="small"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              disabled={!canEdit()}
              name="email"
              type="email"
              label="Email"
              value={individual.email}
              onChange={(e) =>
                dispatch(
                  editVarianceIndividual({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
              size="small"
              sx={{ width: "400px" }}
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
        </CardContent>      </Card>
        </Grid>
        <Grid item xs={4}>
          <ReportedByDetails />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export { IndividualDetails };
